import { type MutableRefObject, memo } from 'react';
import { useAllContentActions } from 'src/components/AllContent/hooks/useAllContentActions';

import { AllContentGalleryView } from '~/components/AllContent/AllContentGalleryView';
import { AllContentTableView } from '~/components/AllContent/AllContentTableView';
import { PrivateView } from '~/components/PrivateGallery/PrivateView';

export type AllContentViewProps = {
  scrollElementRef: MutableRefObject<HTMLDivElement | HTMLElement | null>;
};

/**
 * @deprecated Use SearchPageContent instead
 */
export const AllContentView = memo(({ scrollElementRef }: AllContentViewProps) => {
  const { options } = useAllContentActions({ trackLocation: 'gallery-context-menu' });

  return (
    <PrivateView
      galleryView={<AllContentGalleryView scrollElementRef={scrollElementRef} />}
      tableView={<AllContentTableView scrollElementRef={scrollElementRef} />}
      contextMenuOptions={options}
    />
  );
});

AllContentView.displayName = 'AllContentView';
